/* lua.js generated code 0.3.0 */

require("clover/animation/ui/CommonAnimation")

let SnsProxy = require("clover/sns/SnsProxy")

let MarkRewardPanelRandom = xClass("MarkRewardPanelRandom", BasePanel, function () {
    // WARN: maybe multi result
    return cc.CSLoader.createNode("cocos/mark_prise_random_panel.csb")
})
MarkRewardPanelRandom.prototype.ctor = function (info, randomRewards, canGetRandom, finishCallback, lockTable) {
    let self = this
    self.info = info
    self.randomRewards = randomRewards
    self.canGetRandom = canGetRandom
    BasePanel.prototype.ctor.call(self)
    self.lockTable = lockTable
    self.finishCallback = finishCallback
    self.nodeExist = true
}
MarkRewardPanelRandom.prototype.init = function () {
    let self = this
    BasePanel.prototype.init.call(self)

    let info = self.info
    self.setScale(self.getReferenceScale())
    self.center()
    let rewards = info.lastMarkRewards || (info.markRef[info.markNum] || table()).rewards || table()
    let countPerRow = 4
    let singleLine = true
    if ($len(rewards) >= 5 && $len(rewards) <= 6) {
        countPerRow = 3
    }

    if ($len(rewards) > 4) {
        singleLine = false
    }

    let title2 = self.getChildByName("title2")
    title2.width = self.width
    title2.setTextHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER)
    title2.setAnchorPoint(0.5, 1)
    title2.x = self.width / 2

    // 随机奖励检查2个还是3个
    let randomLight = self.getChildByName("random_bg") // 亮色背景，表示可以领取
    let randomDark = self.getChildByName("random_mask") // 暗色背景，表示不能领取
    let randomBg = randomLight
    if (self.canGetRandom) {
        randomDark.setVisible(false)
        title2.setString("额外奖励（可领取）")
    } else {
        randomDark.setVisible(true)
        randomDark.setOpacity(128)
        title2.setString("额外奖励（不可领取）")
    }
    let randomRewardPosY = randomBg.height / 2 - 3
    let itemViews = []

    function getItemView(itemConfig) {
        let sprite = UIItemBuilder.createPropIcon(itemConfig.itemId)
        sprite.setScale(90 / sprite.getContentSize().width)
        let text = ccui.TextBMFont.create("x" + tostring(itemConfig.num), "font/berlinsansfb_30_bluestroke.fnt")
        text.getVirtualRenderer().setAdditionalKerning(-6)
        text.setName("num")
        text.setScale(sprite.getContentSize().height / 2 / text.getContentSize().height * 4 / 5)
        text.setAnchorPoint(cc.p(0.5, 1))
        let size = sprite.getContentSize()
        text.setPosition(cc.p(size.width, size.height / 2))
        sprite.addChild(text, 10)
        sprite.itemId = itemConfig.itemId
        sprite.num = itemConfig.num
        return [sprite, text]
    }


    let sprites = table()
    let numTable = table()

    if (self.canGetRandom) {
        let randomRewards = clone(self.randomRewards)
        let rewardCount = $len(self.randomRewards)
        // 先把风车币取出来
        let coinIndex = 0
        for (let i = 1, v = randomRewards[1]; v; i++, v = randomRewards[i]) {
            if (v.itemId == GamePropIds.kCash) {
                let [sprite, text] = getItemView(v)
                itemViews.push(sprite)
                sprite.setPosition(randomBg.width * itemViews.length / (rewardCount + 1) - 5, randomRewardPosY)
                randomBg.addChild(sprite)
                table.insert(sprites, sprite)
                table.insert(numTable, text)
                coinIndex = i
                break
            }
        }
        table.remove(randomRewards, coinIndex)

        // 把非风车币道具取出来
        for (let i = 1, v = randomRewards[1]; v; i++, v = randomRewards[i]) {
            let [sprite, text] = getItemView(v)
            itemViews.push(sprite)
            sprite.setPosition(randomBg.width * itemViews.length / (rewardCount + 1) - 5, randomRewardPosY)
            randomBg.addChild(sprite)
            table.insert(sprites, sprite)
            table.insert(numTable, text)
        }
    } else {
        let rewardCount = 2
        for (let i = 1, v = self.randomRewards[1]; v; i++, v = self.randomRewards[i]) {
            if (v.itemId == GamePropIds.kCash) {
                let [sprite, text] = getItemView(v)
                itemViews.push(sprite)
                sprite.setPosition(randomBg.width * itemViews.length / (rewardCount + 1) - 5, randomRewardPosY)
                randomBg.addChild(sprite)
                break
            }
        }

        let chestSprite = cc.Sprite.createWithSpriteFrameName("h5library/mark_random_chest.png")
        chestSprite.setScale(0.95)
        let text = ccui.TextBMFont.create("x1", "font/berlinsansfb_30_bluestroke.fnt")
        text.getVirtualRenderer().setAdditionalKerning(-6)
        text.setName("num")
        text.setScale(chestSprite.getContentSize().height / 2 / text.getContentSize().height * 4 / 5)
        text.setAnchorPoint(cc.p(0.5, 1))
        let size = chestSprite.getContentSize()
        text.setPosition(cc.p(size.width, size.height / 2))
        chestSprite.addChild(text, 10)
        itemViews.push(chestSprite)
        chestSprite.setPosition(randomBg.width * itemViews.length / (rewardCount + 1) - 5, randomRewardPosY)
        randomBg.addChild(chestSprite)
    }



    let btnGet = self.getChildByName("btn_get")
    quickBuildUIGLabelButton(btnGet, function () {
        self.gettingReward(btnGet, sprites, numTable)
    })
    btnGet.setString("领取")

    // “看视频即可获得额外奖励”
    let tip = self.getChildByName("tip")
    tip.setColor(cc.color(255, 255, 255))
    tip.setTextHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER)
    tip.setAnchorPoint(0.5, 1)
    tip.x = self.width / 2

    let itemBg = self.getChildByName("inner_bg")

    // 单行、双行排版调整
    if (singleLine) {
        itemBg.y -= 40
        itemBg.height = 150
        btnGet.y = -680
        title2.y = -350
        randomBg.y = -400
        tip.y = -570

    } else {
        itemBg.height = 300
        title2.y = itemBg.y - itemBg.height - 20
        randomBg.y = title2.y - title2.height
        tip.y = -590
        btnGet.y = -690
    }
    randomDark.y = randomBg.y
    randomDark.height = randomBg.height


    let margin = 25
    let posBase = cc.p(0, 0)
    for (let i = 1, v = rewards[1]; v; i++, v = rewards[i]) {
        let sprite = UIItemBuilder.createPropIcon(v.itemId)
        sprite.setScale(95 / sprite.getContentSize().width)
        let lineCount = Math.min($len(rewards) - Math.floor((i - 1) / countPerRow) * countPerRow, countPerRow)
        let lineWidth = lineCount * sprite.getContentSize().width * sprite.getScale() + (lineCount - 1) * margin
        let idxInLine = (i - 1) % countPerRow + 1
        let lineIdx = Math.floor((i - 1) / countPerRow) + 1
        let text = ccui.TextBMFont.create("x" + tostring(v.num), "font/berlinsansfb_30_bluestroke.fnt")
        text.getVirtualRenderer().setAdditionalKerning(-6)
        text.setName("num")
        text.setScale(sprite.getContentSize().height / 2 / text.getContentSize().height * 4 / 5)
        text.setAnchorPoint(cc.p(0.5, 1))
        let size = sprite.getContentSize()
        text.setPosition(cc.p(size.width, size.height / 2))
        sprite.addChild(text, 10)

        let posX = posBase.x - lineWidth / 2 + (idxInLine - 1) * margin + (idxInLine - 0.5) * sprite.getContentSize().width * sprite.getScale()
        let posY
        if (singleLine) {
            posY = itemBg.height / 2
        } else {
            posY = posBase.y - (lineIdx - 1) * margin - (lineIdx - 0.5) * sprite.getContentSize().height * sprite.getScale() + 260
        }
        sprite.setPosition(cc.p(posX + itemBg.width / 2, posY))
        itemBg.addChild(sprite, 120)
        sprite.itemId = v.itemId
        sprite.num = v.num
        table.insert(sprites, sprite)
        table.insert(numTable, text)
    }

    self.closeBtn = self.getChildByName("btn_close")
    quickBuildUIBUtton(self.closeBtn, () => {
        self.gettingReward(btnGet, sprites, numTable)
    })

    if (!SnsProxy.getInstance().allowAd()) {
        tip.setVisible(false);
        title2.setVisible(false);
        randomLight.setVisible(false);
        randomDark.setVisible(false);
        itemBg.setPosition(itemBg.x, itemBg.y - 120)
    }
}
MarkRewardPanelRandom.prototype.rewardItemGlowAnim = function () {
    let self = this
    // WARN: maybe multi result
    return CommonAnimation.createStarGlowAnimation()
}
MarkRewardPanelRandom.prototype.gettingReward = function (button, sprites, numTable) {
    let self = this
    let proced = false
    if (proced) {
        return
    }
    proced = true
    let rewardItems = table()
    for (let i = 1, v = sprites[1]; v; i++, v = sprites[i]) {
        table.insert(rewardItems, table(
            [1, "itemId", v.itemId],
            [1, "num", v.num],
            [1, "icon", v]
        ))
    }

    if (self.canGetRandom) {
        for (var i = 1, v = self.randomRewards[1]; v; i++ , v = self.randomRewards[i]) {
            v.itemId = tonumber(v.itemId)
            v.num = tonumber(v.num)
            UserProp.getInstance().rewardProp(v.itemId, v.num, null, null, ModuleName.MARK)
        }
    }

    if ($len(rewardItems) > 0) {
        self.rewardItemAnims(rewardItems, function () {
            if (self.finishCallback) {
                self.finishCallback()
            }
            if (self.nodeExist) {
                self.onClose()
            }
        })
    }
    for (let i = 1, v = sprites[1]; v; i++, v = sprites[i]) {
        v.removeFromParent(true)
    }
    for (let i = 1, v = numTable[1]; v; i++, v = numTable[i]) {
        v.removeFromParent(true)
    }
    let scale = button.getScaleX()
    button.runAction(cc.Sequence.create(cc.Spawn.create(cc.ScaleTo.create(0.2, 0.4 * scale), cc.FadeOut.create(0.2)), cc.CallFunc.create(function () {
        button.removeFromParent(true)
    })))
}
MarkRewardPanelRandom.prototype.rewardItemAnims = function (items, finishCallback) {
    let self = this
    let flyItemOps = table()

    function onAnimFinish() {
        if (finishCallback) {
            finishCallback()
        }
    }
    for (let i = 1, v = items[1]; v; i++, v = items[i]) {
        let parent = v.icon.getParent()
        if (parent) {
            let pos = parent.convertToWorldSpace(cc.p(v.icon.getPosition()))
            table.insert(flyItemOps, table(
                [1, "itemId", v.itemId],
                [1, "num", v.num],
                [1, "pos", pos]
            ))
        }
    }
    if (type(self.lockTable) === "table") {
        let HomeScene = require("clover/scene/HomeScene")
        let infoBanner = HomeScene.getInstance().infoBanner
        infoBanner.releaseCoin(self.lockTable.coin || 0)
        infoBanner.releaseCash(self.lockTable.cash || 0)
    }
    if ($len(flyItemOps) > 0) {
        HomeSceneAnimation.playGetPropAnimation(flyItemOps, onAnimFinish, 0.15)
    }
}

MarkRewardPanelRandom.prototype.remove = function () {
    let self = this
    cc.log("MarkRewardPanelRandom:remove")
    self.onExitAnimStart()
    PopoutManager.getInstance().remove(self)
}
MarkRewardPanelRandom.prototype.onKeyBackClicked = function () {}
module.exports = MarkRewardPanelRandom